import React from 'react'

const e = React.createElement;


function GraphSizes(props) {
  React.Component.constructor.call(this);

  this.state = {graph_offset:null, graph_offset_init:false};
}
GraphSizes.prototype = Object.create(React.Component.prototype);


GraphSizes.prototype.render = function() {
  const data = this.props.data;
  const goal_data = this.props.goal_data;
  var canvas = document.getElementById("canvasgraphsizes");

  if(canvas) {
    var ctx = canvas.getContext("2d");
    var values = {}, max_value = 0, min_value = 0;
    var d, d2;
    if(data[0] !== undefined) {
      data.map(function(item, i) {
        var d = new Date(item.date);
        var key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
        values[key] = item.weight;
        if(item.weight > max_value) max_value = item.weight;
        if(item.weight < min_value || min_value === 0) min_value = item.weight;
      });
      d = new Date(data[data.length - 1].date);
      d2 = new Date(data[0].date);
    }

    if(goal_data[0] !== undefined) {
      var sd = new Date(goal_data[0].start_date);
      var gd = new Date(goal_data[0].goal_date);
      if(typeof d === "undefined" || sd.getTime() < d.getTime()) {
        d = sd;
      }
      if(typeof d2 === "undefined" || gd.getTime() > d2.getTime()) {
        d2 = gd;
      }
    }
    var last_key = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();

    var dates = {};
    var date_i = 0, start_date_i = 0, goal_date_i = 0, today_i = 0;
    for(var loop_stop = 0; loop_stop < 1;) {
      var key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      dates[key] = 0;
      if(goal_data[0] !== undefined) {
        var sd = new Date(goal_data[0].start_date);
        var gd = new Date(goal_data[0].goal_date);
        var td = new Date();
        var sd_key = sd.getFullYear()+"-"+(sd.getMonth()+1)+"-"+sd.getDate();
        var gd_key = gd.getFullYear()+"-"+(gd.getMonth()+1)+"-"+gd.getDate();
        var td_key = td.getFullYear()+"-"+(td.getMonth()+1)+"-"+td.getDate();
        if(sd_key === key) {start_date_i = date_i;}
        if(gd_key === key) {goal_date_i = date_i;}
        if(td_key === key) {today_i = date_i;}
      }

      d.setDate(d.getDate() + 1);
      if(key === last_key) {
        loop_stop++;
      }
      date_i++;
    }

    // todo: offset was * 37, now * 14, but too wide for mobile. Change to check window/canvas size or something.
    canvas.width = Object.keys(dates).length *14 + 6;
    if(!this.state.graph_offset_init) {
      var new_graph_offset = -((today_i-14) *14 + 6);
      setTimeout(function() {
        this.setState({graph_offset:new_graph_offset, graph_offset_init:true});
      }.bind(this), 0);
    }

    if(goal_data[0] !== undefined) {
      if(data[0] !== undefined) {
        if(goal_data[0].start_weight > max_value) {
          max_value = goal_data[0].start_weight;
        } else if(goal_data[0].start_weight < min_value) {
          min_value = goal_data[0].start_weight;
        }
        if(goal_data[0].goal_weight > max_value) {
          max_value = goal_data[0].goal_weight;
        } else if(goal_data[0].goal_weight < min_value) {
          min_value = goal_data[0].goal_weight;
        }
      } else {
        if(goal_data[0].start_weight > goal_data[0].goal_weight) {
          max_value = goal_data[0].start_weight;
          min_value = goal_data[0].goal_weight;
        } else {
          min_value = goal_data[0].start_weight;
          max_value = goal_data[0].goal_weight;
        }
      }
    }

    ctx.fillStyle = "#72FFAA";
    ctx.textAlign = "center";
    ctx.lineWidth = 2;

    if(goal_data[0] !== undefined) {
      ctx.fillStyle = "#c549f9";
      ctx.strokeStyle = "#c549f9";
      var perc_start = Math.floor((goal_data[0].start_weight - min_value) / (max_value - min_value) * 100);
      var perc_goal = Math.floor((goal_data[0].goal_weight - min_value) / (max_value - min_value) * 100);

      if(start_date_i > 0) {
        ctx.lineWidth = 30;
        ctx.strokeStyle = "#c549f96e";
        ctx.beginPath(); // thick line for margin, between this and start date
        ctx.moveTo(23+0*14, 110-perc_start);
        ctx.lineTo(23+start_date_i*14, 110-perc_start);
        ctx.stroke();

        ctx.lineWidth = 2;
        ctx.strokeStyle = "#c549f9";
        ctx.beginPath(); // line between this and start date
        ctx.moveTo(23+0*14, 110-perc_start);
        ctx.lineTo(23+start_date_i*14, 110-perc_start);
        ctx.stroke();

        ctx.beginPath(); // dot/point of value in graph
        ctx.arc(23+0*14, 110-perc_start, 4, 0, 2 * Math.PI);
        ctx.fill();
      }

      if(goal_date_i < (Object.keys(dates).length - 1)) {
        ctx.lineWidth = 30;
        ctx.strokeStyle = "#c549f96e";
        ctx.beginPath(); // thick line for margin, between this and start date
        ctx.moveTo(23+(Object.keys(dates).length - 1)*14, 110-perc_goal);
        ctx.lineTo(23+goal_date_i*14, 110-perc_goal);
        ctx.stroke();

        ctx.lineWidth = 2;
        ctx.strokeStyle = "#c549f9";
        ctx.beginPath(); // line between this and start date
        ctx.moveTo(23+(Object.keys(dates).length - 1)*14, 110-perc_goal);
        ctx.lineTo(23+goal_date_i*14, 110-perc_goal);
        ctx.stroke();

        ctx.beginPath(); // dot/point of value in graph
        ctx.arc(23+(Object.keys(dates).length - 1)*14, 110-perc_goal, 4, 0, 2 * Math.PI);
        ctx.fill();
      }

      ctx.lineWidth = 30;
      ctx.strokeStyle = "#c549f96e";
      ctx.beginPath(); // thick line for margin, between this and start date
      ctx.moveTo(23+start_date_i*14, 110-perc_start);
      ctx.lineTo(23+goal_date_i*14, 110-perc_goal);
      ctx.stroke();

      ctx.lineWidth = 2;
      ctx.strokeStyle = "#c549f9";
      ctx.beginPath(); // line between this and start date
      ctx.moveTo(23+start_date_i*14, 110-perc_start);
      ctx.lineTo(23+goal_date_i*14, 110-perc_goal);
      ctx.stroke();

      ctx.beginPath(); // dot/point of value in graph
      ctx.arc(23+start_date_i*14, 110-perc_start, 4, 0, 2 * Math.PI);
      ctx.fill();

      ctx.beginPath(); // dot/point of value in graph
      ctx.arc(23+goal_date_i*14, 110-perc_goal, 4, 0, 2 * Math.PI);
      ctx.fill();

      ctx.fillStyle = "#c549f9"; // value overlay
      ctx.fillText(goal_data[0].start_weight.toString().replace(".", ","), 23+start_date_i*14, 60);
      ctx.fillText(goal_data[0].goal_weight.toString().replace(".", ","), 23+goal_date_i*14, 60);
    }

    var dates_i = 0, months = [];
    var prev_value_key = "";
    var prev_value_i = "";
    ctx.strokeStyle = "#000000";
    ctx.lineWidth = 2;
    for(var key in dates) {
      if(values[key]) {
        var perc = Math.floor((values[key] - min_value) / (max_value - min_value) * 100);
        ctx.fillStyle = "#000000";
        ctx.beginPath(); // dot/point of value in graph
        ctx.arc(23+dates_i*14, 110-perc, 4, 0, 2 * Math.PI);
        ctx.fill();

        if(prev_value_key !== "") {
          ctx.beginPath(); // line between this and previous value in graph
          ctx.moveTo(23+dates_i*14, 110-perc);
          var perc2 = Math.floor((values[prev_value_key] - min_value) / (max_value - min_value) * 100);
          ctx.lineTo(23+(prev_value_i)*14, 110-perc2);
          ctx.stroke();
        }

        ctx.fillStyle = "#15a033"; // value overlay
        ctx.fillText(values[key].toString().replace(".", ","), 23+dates_i*14, 104);

        prev_value_key = key;
        prev_value_i = dates_i;
      }

      var label = key.split("-");
      ctx.fillStyle = "#222222"; // days
      ctx.fillText(label[2], 23+dates_i*14, 120);

      if(months.indexOf(label[0]+"-"+label[1]) === -1) {
        ctx.fillStyle = "#bbbbbb"; // months
        if(label[1] === "1") {
          ctx.fillText(label[1]+"-"+label[0], 23+dates_i*14, 130);
        } else {
          ctx.fillText(label[1], 23+dates_i*14, 130);
        }
        months.push(label[0]+"-"+label[1]);
      }
      ctx.fillStyle = "#72FFAA";

      dates_i++;
    }
  } else {
    setTimeout(function() {
      this.setState({reload:true});
    }.bind(this), 0);
  }

  return e('div', {className:"card"}, e('div', {id:"graphsizes-wrapper", style:{overflow:"hidden"}}, [
    e('span', {key:"left", className:"graph-arrow", onClick:this.moveGraph.bind(this, false)}, "<"),
    e('span', {key:"right", className:"graph-arrow", onClick:this.moveGraph.bind(this, true), style:{marginLeft:"22px"}}, ">"),
    e('span', {key:"max", style:{float:"right", fontSize:"62%", opacity:".4"}}, min_value > 0 && "max. "+max_value.toString().replace(".", ",")+" - min. "+min_value.toString().replace(".", ",")),
    e('canvas', {key:"canvas", id:"canvasgraphsizes", width:"0px", height:"140px", style:{marginLeft:this.state.graph_offset}})
  ]));
}

GraphSizes.prototype.moveGraph = function(move_right) {
  var canvas_wrapper = document.getElementById("graphsizes-wrapper");
  var max_width = canvas_wrapper.offsetWidth;
  var canvas = document.getElementById("canvasgraphsizes");

  var new_offset = -480;
  var new_graph_offset = this.state.graph_offset;
  if(canvas.width > 0) {
    if(!move_right && new_graph_offset < 0) {
      new_graph_offset = this.state.graph_offset - new_offset;
      if(new_graph_offset > 0) new_graph_offset = 0;
    }
    if(move_right && canvas.width + this.state.graph_offset > max_width) {
      new_graph_offset = this.state.graph_offset + new_offset;
      if(canvas.width + new_graph_offset < max_width) new_graph_offset = -(canvas.width - max_width);
    }
  }
  this.setState({graph_offset:new_graph_offset});
}


export default GraphSizes



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/GraphSizes.js
// module id = 199
// module chunks = 0